import { DatePipe } from '@angular/common';
import { Component, HostBinding, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { NgbCalendar, NgbDatepickerConfig, NgbDateStruct, NgbModal, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { ModalMotivoRechazoComponent } from '@cliente/clientes-aprobar-modificaciones/modal-motivo-rechazo/modal-motivo-rechazo.component';
import { Motivo } from '@shared/enums/Motivo';
import { TipoAerovale } from '@shared/enums/tipoAerovale';
import { Aeroplanta } from '@shared/models/despacho/Aeroplanta';
import { Aerovale } from '@shared/models/despacho/Aerovale';
import { AerovaleDetalle } from '@shared/models/despacho/AerovaleDetalle';
import { ErrorModel } from '@shared/models/ErrorModel';
import { Comprobante } from '@shared/models/facturacion/Comprobante';
import { Factura } from '@shared/models/facturacion/Factura';
import { RefacturacionFactura } from '@shared/models/facturacion/RefacturacionFactura';
import { TuplaRefacturacion } from '@shared/models/facturacion/TuplaRefacturacion';
import { TipoMovimientoPipe } from '@shared/pipes/tipo-movimiento.pipe';
import { SharedService } from '@shared/shared.service';
import { MessageService } from '@shell/message.service';
import { ComprobanteService } from '../comprobante.service';
import { FacturacionService } from '../facturacion.service';
import { TipoModalObservacion } from "@shared/enums/TipoModalObservacion";
import { MotivosObservacionesComponent } from "@shared/components/motivos-observaciones/motivos-observaciones.component";
import { ActivatedRoute } from '@angular/router';
import { TipoUsuario } from '@shared/enums/tipoUsuario';
import { CondicionVenta } from '@shared/enums/condicionVenta';
import { AuthService } from '@authentication/auth.service';
import { EstadoRefacturacion } from '@shared/enums/estadoRefacturacion';

@Component({
  selector: 'app-revision-refacturacion',
  templateUrl: './revision-refacturacion.component.html',
  styleUrls: ['./revision-refacturacion.component.css']
})
export class RevisionRefacturacionComponent implements OnInit, OnDestroy {

  @HostBinding('class.changed')

  tablaComprobantes: UntypedFormGroup;
  aeroplanta: Aeroplanta;
  tituloFactura: string;
  facturas: RefacturacionFactura[] = [];
  facturasFiltradas: RefacturacionFactura[] = [];
  facturasSeleccionadas: RefacturacionFactura[] = [];
  aceptandoRefacturacion: boolean = false;
  rechazandoFacturacion: boolean = false;
  facturaCalculada: Factura[];
  facturaObtenida: Comprobante;
  aerovaleDetalle: AerovaleDetalle;
  previsualizacion: boolean = false;
  cargandoPrevisualizacion: boolean = false;
  aerovales: Aerovale[] = [];
  aerovalesFiltrados: Aerovale[] = [];
  aerovaleActual: Aerovale;
  fechaHasta = new UntypedFormControl();
  fechaFormControlDesdeHasta = new UntypedFormControl();
  mensajeErrorExportar = "";
  model: NgbDateStruct;
  model1: NgbDateStruct;
  time: NgbTimeStruct;
  startDate: Date;
  endDate: Date;
  buscando: boolean = false;
  mensajeSpinner: string = "D e s c a r g a n d o";
  obteniendoAerovales = true;
  cambiandoAeroplanta: boolean = false;
  pendiente = { valor: "Pendiente", descripcion: "Pendiente", seleccionado: false };
  finalizado = { valor: "Finalizado", descripcion: "Finalizado", seleccionado: false };
  finalizadoSinFirma = { valor: "FinalizadoSinFirma", descripcion: "Finalizado sin firma", seleccionado: false };
  estadoSincronizado = { valor: "Sincronizado", descripcion: "Sincronizado", seleccionado: false };
  anulado = { valor: "Anulado", descripcion: "Anulado", seleccionado: false };

  notaCredito = { tipo: 0, valor: "notaCredito", descripcion: "Nota de credito", seleccionado: false };
  notaDebito = { tipo: 1, valor: "notaDebito", descripcion: "Nota de debito", seleccionado: false };

  tipos = [
    this.notaCredito, this.notaDebito
  ];

  estados = [
    this.pendiente,
    this.finalizado,
    this.estadoSincronizado,
    this.anulado
  ];
  busquedaFormControl = new UntypedFormControl();
  change$: Subscription;
  errorAerovales: boolean = false;
  tipoNuevoAerovale: TipoAerovale;
  TipoUsuario: TipoUsuario;
  enumTipoAerovale = TipoAerovale;
  idComprobanteAsociado: string;
  botonAnular: boolean = false;
  itemSeleccionado: number = null;
  motivo = Motivo;

  rolRefacturacion: boolean;

  params: any = null;

  constructor(private datepickerConfig2: NgbDatepickerConfig,
    private messageService: MessageService,    
    private calendar: NgbCalendar,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    private fb: UntypedFormBuilder,
    private comprobanteService: ComprobanteService,
    public facturacionService: FacturacionService,
    private datePipe: DatePipe,
    private tipoMovimientoPipe: TipoMovimientoPipe,
    private router: ActivatedRoute,
    public sharedService: SharedService,
    private authService: AuthService) {
      this.change$ = sharedService.aeroplantaSeleccionada.subscribe(()=>{
        this.cambiarDeAeroplanta()
      })
    }

  ngOnInit() {
    this.tablaComprobantes = this.fb.group({
      aerovalesFiltrados: new UntypedFormArray([])
    });
    this.addCheckboxes();
    this.idComprobanteAsociado = '';
    this.botonAnular = false;
    this.mensajeSpinner = "C a r g a n d o . . .";
    this.model = this.calendar.getToday();
    this.model1 = this.calendar.getToday();
    const inicio: any = { day: 1, month: 1, year: 2019 };
    this.datepickerConfig2.minDate = inicio;
    const fin: any = { day: this.model.day, month: this.model.month, year: this.model.year };
    this.model1 = this.calendar.getToday();
    this.datepickerConfig2.maxDate = fin;
    setTimeout(() => {
      this.spinner.show('spinnerGrafico');
    });
    this.router.queryParams.subscribe(params => {
      this.params=params;
    });  
    if(this.authService.hasRole(TipoUsuario.FACTURACION) || this.authService.hasRole(TipoUsuario.REFACTURACION)){
      this.rolRefacturacion = true;
    } else this.rolRefacturacion = false;    
    this.reinicioFechaInicioFechaFin();
    this.getRevisionesPorRango(this.startDate, this.endDate);
  }

  ngOnDestroy() {
    this.change$.unsubscribe();
    this.aerovalesFiltrados = [];
  }

  filtrarFacturas() {
    this.facturasFiltradas = this.facturas.filter(a => {
      let agregar = true;
      if (this.busqueda.value) {
        agregar = a.factura.razonSocialCliente.toLowerCase().indexOf(this.busqueda.value.toLowerCase()) > -1;
        agregar = agregar || (this.facturacionService.formatearComprobante(a.factura.prefijo,a.factura.numeroComprobante).indexOf(this.busqueda.value) > -1);
        agregar = agregar || (this.datePipe.transform(a.factura.fechaEmision, "d/MM/y").indexOf(this.busqueda.value) > -1);
        agregar = agregar || (this.tipoMovimientoPipe.transform(a.factura.tipoMovimiento).indexOf(this.busqueda.value) > -1);
      }
      return agregar;
    });
  }

  getRevisionesPorRango(fechaInicio: Date, fechaFin: Date) {
    this.obteniendoAerovales = true;
    this.aerovales = [];
    this.aerovalesFiltrados = [];
    this.spinner.show('spinnerGrafico');
    const desde: string = this.sharedService.formatDate(fechaInicio.getFullYear(), fechaInicio.getMonth() + 1, fechaInicio.getDate(), 0, 0);
    const hasta: string = this.sharedService.formatDate(fechaFin.getFullYear(), fechaFin.getMonth() + 1, fechaFin.getDate(), 23, 59);
    this.facturacionService.getRefacturaciones(desde, hasta, this.params.estado == 'validacionComercial' ? EstadoRefacturacion.ValidacionComercial : EstadoRefacturacion.Pendiente)
      .subscribe(result => {
        this.facturas = result;
        if(this.params.estado !== 'validacionComercial') {
          this.facturas = this.facturas.filter(f => this.rolRefacturacion ? f.factura.condicionVenta !== CondicionVenta.contado : f.factura.condicionVenta === CondicionVenta.contado);
        }
        this.facturasFiltradas = this.facturas;
        this.spinner.hide('spinnerGrafico');
        this.obteniendoAerovales = false;
      }, () => {
        this.errorAerovales = true;
        this.obteniendoAerovales = false;
      });
  }

  reinicioFechaInicioFechaFin() {
    this.startDate = new Date(this.model.year, this.model.month - 1, this.model.day);
    this.endDate = new Date(this.model1.year, this.model1.month - 1, this.model1.day);
    this.endDate.setHours(23, 59, 59, 99);
  }

  buscarDesdeHasta() {
    this.facturasSeleccionadas = [];
    this.mensajeErrorExportar = "";
    this.aerovalesFiltrados = null;
    this.aerovaleActual = null;
    this.mensajeSpinner = "C a r g a n d o . . .";
    this.buscando = true;
    this.reinicioFechaInicioFechaFin();
    this.getRevisionesPorRango(this.startDate, this.endDate);
  }

  verObservaciones(motivos: string) {
    console.log("El motivo es " + JSON.stringify(motivos));
    const modalRef = this.modalService.open(MotivosObservacionesComponent, { centered: true, backdrop: 'static' });
    modalRef.componentInstance.motivos = motivos;
    modalRef.componentInstance.titulo = "Observaciones";
    modalRef.componentInstance.tipoObservacion = TipoModalObservacion.Refacturacion;
  }

  verComparativasFacturas(content, factura: RefacturacionFactura, index) {
    this.cargandoPrevisualizacion = true;
    this.itemSeleccionado = index;
    this.facturaObtenida = factura.factura;
    this.tituloFactura = 'Factura: ' + factura.factura.prefijo + '-' + factura.factura.numeroComprobante + ' Fecha: ' + new Date().toLocaleDateString();
    this.comprobanteService.obtenerComprobantePorPrefijoNumeroTipo(this.facturaObtenida.prefijo, this.facturaObtenida.numeroComprobante, this.facturaObtenida.tipoMovimiento)
      .subscribe(result => {
        this.facturaObtenida = result;
        if (result != null) {
          this.previsualizacion = false;
          this.facturacionService.getNuevoComprobante(factura.id, factura.esRefacturacionTotal)
            .subscribe(result => {
              this.facturaCalculada = result;
              this.previsualizacion = true;
              this.cargandoPrevisualizacion = false;
              this.itemSeleccionado = -1;
              this.obteniendoAerovales = false;
              this.spinner.hide('spinnerGrafico');
              this.modalService.open(content, { windowClass: 'custom-modal', centered: true, size: 'lg' });
            })
        }
        else {
          this.cargandoPrevisualizacion = false;
          this.itemSeleccionado = -1;
          this.facturaObtenida = null; //se limpia el comprobante.
        }
      },
        () => {
          // Entra aquí si el servicio entrega un código http de error EJ: 404,
          //500
          this.cargandoPrevisualizacion = false;
          this.itemSeleccionado = -1;
          this.facturaObtenida = null; //se limpia el comprobante.
        });
  }

  limpiarCampos() {
    this.aerovalesFiltrados = [];
    this.spinner.hide("spinnerLista");
    this.spinner.hide("spinnerDetalle");
    this.buscando = false;
    this.busquedaFormControl.reset();
    this.model = this.calendar.getToday();
    this.model1 = this.calendar.getToday();
    //limpio filtro estados
    this.estados.forEach(estado => estado.seleccionado = false)
    //limpio filtro tipos
    this.tipos.forEach(tipo => tipo.seleccionado = false)
  }

  cambiarDeAeroplanta() {
    this.cambiandoAeroplanta = false;
    this.limpiarCampos();
    this.cambiandoAeroplanta = true;
    this.ngOnInit();
  }

  private addCheckboxes() {
    // reinicio el formulario
    this.tablaComprobantes.setControl('aerovalesFiltrados', this.fb.array([]));
    this.aerovalesFiltrados.map((o, i) => {
      const control = new UntypedFormControl(i === 0); // if first item set to true, else false
      control.setValue(o);
      (this.tablaComprobantes.controls.aerovalesFiltrados as UntypedFormArray).push(control);
    });
  }

  seleccionarFactura(factura) {
    const indice = this.facturasSeleccionadas.indexOf(factura);
    if (indice != -1) {
      this.facturasSeleccionadas.splice(indice, 1);
    } else {
      this.facturasSeleccionadas.push(factura);
    }
  }

  revisarRefactura() {
    this.aceptandoRefacturacion = true;
    const refacturacion = new RefacturacionFactura();
    const tupla: TuplaRefacturacion[] = [];
    for (const fact of this.facturasSeleccionadas) {
      const t = new TuplaRefacturacion();
      t.esRefacturacionTotal = fact.esRefacturacionTotal;
      t.refacturacionFacturaId = fact.id
      tupla.push(t);
    }
    refacturacion.tupla = tupla;
    refacturacion.responsable = this.obtenerStringUsuarioSolicitador();
    refacturacion.estado = this.params.estado == "validacionComercial" ? EstadoRefacturacion.ValidacionComercial : EstadoRefacturacion.Pendiente// pendiente
    refacturacion.estadoFinal = this.params.estado == 'validacionComercial' ? EstadoRefacturacion.Pendiente : EstadoRefacturacion.Revisado // revisado
    this.facturacionService.actualizarRefacturacion(refacturacion)
      .subscribe(() => {
        this.messageService.showSuccessMessage("Se ha realizado correctamente la refacturación de la factura ");
        this.facturasSeleccionadas = [];
        this.ngOnInit();
        this.aceptandoRefacturacion = false;
      }, (err: ErrorModel) => {
        this.aceptandoRefacturacion = false;
        this.facturasSeleccionadas = [];
        this.messageService.showErrorMessage("Hubo un error al realizar la refacturación. " + err.description + ' ' + err.message);
      });
  }

  rechazarRefactura() {
    if (this.facturasSeleccionadas.length == 0) {
      this.messageService.showErrorMessage('No se seleccionó ninguna factura para rechazar.');
      return;
    } else {
      const modalRef = this.modalService.open(ModalMotivoRechazoComponent, { size: 'lg', backdrop: 'static' });
      modalRef.result.then((motivo) => {
        if (motivo == null) {
          return;
        }
        this.accionRechazar(motivo);
      }).catch(() => {
        return;
      });
    }
  }

  accionRechazar(motivo) {
    this.rechazandoFacturacion = true;
    const refacturacion = new RefacturacionFactura();
    const tupla: TuplaRefacturacion[] = [];
    for (const fact of this.facturasSeleccionadas) {
      const t = new TuplaRefacturacion();
      t.esRefacturacionTotal = fact.esRefacturacionTotal;
      t.refacturacionFacturaId = fact.id
      tupla.push(t);
    }
    refacturacion.tupla = tupla;
    refacturacion.responsable = this.obtenerStringUsuarioSolicitador();
    refacturacion.estado = this.params.estado == 'validacionComercial' ?  EstadoRefacturacion.ValidacionComercial : EstadoRefacturacion.Pendiente;
    refacturacion.estadoFinal = EstadoRefacturacion.Rechazado;
    refacturacion.motivoRechazo = motivo;
    this.facturacionService.actualizarRefacturacion(refacturacion)
      .subscribe(() => {
        this.facturasSeleccionadas = [];
        this.rechazandoFacturacion = false;
        this.messageService.showSuccessMessage("Se ha realizado correctamente el rechazo de la revision");
        this.ngOnInit();
      }, (err:ErrorModel) => {
        this.facturasSeleccionadas = [];
        this.rechazandoFacturacion = false;
        this.messageService.showErrorMessage("Hubo un error al realizar el rechazo de la revision. " + err.description + ' ' + err.message);
      });
  }

  // getters
  get busqueda() {
    return this.busquedaFormControl;
  }

  obtenerMotivoRefacturacion(numero: string) {
    return Motivo[numero];
  }

  obtenerStringUsuarioSolicitador() {
    return this.facturacionService.obtenerStringSolicitador();
  }
}
